/**
=========================================================
* Soft UI Dashboard PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-material-ui
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Components
import { Typography, List, ListItem } from "@mui/material";
import Box from "@mui/material/Box";

import { useTranslation } from "react-i18next";

function HelpModalScreen() {
  const { t } = useTranslation(["help"]);

  const stateCodes = [
    "OPEN",
    "PUBLISHED",
    "CLEARED",
    "WAITING_SETTLEMENT",
    "WAITING_DSO_COEFFICIENTS",
    "WAITING_DSO_INFO",
    "NO_TRANSACTIONS",
    "SETTLED",
    "ERROR",
    "LOADS_CONVERSION_ERROR",
    "CLEAR_ERROR",
    "SETTLEMENT_ERROR",
  ];

  const memberItems = [
    "balance",
    "aci",
    "internal_trades",
    "sc_tariffs_cost",
    "retailer_buy_cost",
    "retailer_sell_revenue",
  ];

  const memberResourceItems = [
    "balance",
    "internal_trades",
    "retailer_buy_cost",
    "retailer_sell_revenue",
  ];

  return (
    <Box sx={{ overflow: "scroll", overflowX: "hidden", maxHeight: "85vh", padding: "1rem" }}>
      <Typography variant="h1" mb={2}>
        {t("settlement_list.title")}
      </Typography>
      <hr />

      {/* Sobre */}
      <Typography variant="h3" mt={4} ml={2}>
        {t("settlement_list.about.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("settlement_list.about.body")}
        </Box>
      </Typography>

      {/* Estado da Sessão */}
      <Typography variant="h3" mt={4} ml={2}>
        {t("settlement_list.session_state.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("settlement_list.session_state.intro")}
        </Box>
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {stateCodes.map((code) => (
            <Typography key={code} component="div" variant="text" fontWeight={700} fontSize="1rem">
              - {t(`settlement_list.session_state.codes.${code}`)}
            </Typography>
          ))}
        </Box>
      </Typography>

      {/* Mensagem */}
      <Typography variant="h3" mt={4} ml={2}>
        {t("settlement_list.message.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("settlement_list.message.body")}
        </Box>
      </Typography>

      {/* Balanço Económico dos Membros */}
      <Typography variant="h3" mt={4} ml={2}>
        {t("settlement_list.members_balance.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("settlement_list.members_balance.intro")}
        </Box>
      </Typography>
      <Box ml={6}>
        <List component="ul">
          {memberItems.map((key) => (
            <ListItem key={key} component="li" divider>
              <Typography variant="text" fontSize="1rem" mt={2}>
                <Typography component="span" variant="text" fontWeight={700} fontSize="1rem">
                  {t(`settlement_list.members_balance.items.${key}.title`)}{" "}
                </Typography>
                {t(`settlement_list.members_balance.items.${key}.body`)}
              </Typography>
            </ListItem>
          ))}
        </List>
      </Box>

      {/* Balanço Económico Membros-Recursos */}
      <Typography variant="h3" mt={4} ml={2}>
        {t("settlement_list.member_resource_balance.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("settlement_list.member_resource_balance.intro")}
        </Box>
      </Typography>
      <Box ml={6}>
        <List component="ul">
          {memberResourceItems.map((key) => (
            <ListItem key={key} component="li" divider>
              <Typography variant="text" fontSize="1rem" mt={2}>
                <Typography component="span" variant="text" fontWeight={700} fontSize="1rem">
                  {t(`settlement_list.member_resource_balance.items.${key}.title`)}{" "}
                </Typography>
                {t(`settlement_list.member_resource_balance.items.${key}.body`)}
              </Typography>
            </ListItem>
          ))}
        </List>
      </Box>
    </Box>
  );
}

export default HelpModalScreen;
